module.exports = __webpack_public_path__ + "media/images/contest-disabled-label-center@2x-f93e018b5cc7075006832c2d1df585bc.png";